<template lang="pug">
b-nav.my-2(pills, vertical, card-header)
  b-nav-item(
    v-for="item in navItems",
    :key="item.route",
    :to="`/user${item.route}`",
    active-class="profile-nav-item-active",
    link-classes="profile-nav-item rounded-0 text-gray-700 py-1 my-1"
  )
    .d-flex.align-items-center.my-1
      i.mr-2(:class="`icon-${item.icon}`")
      span.profile-nav-content.font-weight-medium {{ item.label }}
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        {
          route: "/profile/details",
          icon: "human-head",
          label: "Basic Details",
        },
        {
          route: "/profile/about",
          icon: "men",
          label: "About You",
        },
        {
          route: "/profile/contact-details",
          icon: "at-the-rate",
          label: "Contact Details",
        },
        {
          route: "/dependents",
          icon: "users",
          label: "Dependents",
        },
        {
          route: "/profile/security",
          icon: "key",
          label: "Security",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";
.profile-nav-item:hover {
  color: $gray-800;
}
.profile-nav-item-active {
  background-color: unset;
  color: $gray-900 !important;
  border-right: 2px solid $gray-900 !important;
  .profile-nav-content {
    font-weight: 600 !important;
  }
}
</style>
